<template>
  <div>
    <button id="back-top" class="back-to-top" @click="topFunction()" ><span class="ti-angle-up"></span></button>
  </div>
</template>

<script>
export default {
  methods: {
    scrollFunction() {
      //Get the button
      let mybutton = document.getElementById("back-top");
      if (document.body.scrollTop > 150 || document.documentElement.scrollTop > 150) {
        mybutton.style.display = "block";
      } else {
        mybutton.style.display = "none";
      }
    },

    topFunction() {
      // When the user clicks on the button, scroll to the top of the document
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
  },
  created() {
    window.addEventListener('scroll', this.scrollFunction);
  },

  destroyed() {
    window.removeEventListener('scroll', this.scrollFunction);
  }
}
</script>

<style scoped>
/* Back to top button */
 .back-to-top {
    position: fixed;
    display: none;
    width: 40px;
    height: 40px;
    border-radius: 3px;
    right: 15px;
    bottom: 15px;
    background: #0A2463;
    color: #fff;
    transition: display 0.5s ease-in-out;
    z-index: 99999;
    border: none;
}

.back-to-top .ti-angle-up {
    font-size: 24px;
    position: absolute;
    top: 8px;
    left: 8px;
    color: #fff;
}

.back-to-top:hover {
    color: #fff;
    background: #333456;
    transition: background 0.2s ease-in-out;
}

</style>
